module.exports = __webpack_public_path__ + "img/arrow-down-to-line.01557645.svg";